import React, { createContext, useContext, useState, useEffect } from 'react';

interface SampleQuestion {
  id: string;
  topic: string;
  question: string;
  description: string;
  icon: string;
}

interface DemoContextType {
  isDemoMode: boolean;
  toggleDemoMode: () => void;
  setDemoMode: (enabled: boolean) => void;
  sampleQuestions: SampleQuestion[];
}

const defaultSampleQuestions: SampleQuestion[] = [
  {
    id: 'environmental',
    topic: 'Environmental',
    question: "I work in Envirornmental Protection and Conservation in Georgia and I'm looking for an analysis on recent bills in the space. What types of bills or trends have Georgia legislators been sponsoring or geting on board with? What are the issues?",
    description: 'Environmental protection and climate priorities in Georgia',
    icon: '🌍'
  },
  {
    id: 'ai',
    topic: 'AI',
    question: 'My company is deploying AI systems nationally. Can you give me a federal rundown? Any key people or committees we should target?',
    description: 'Federal AI landscape, key committees, and targets',
    icon: '🤖'
  },
  {
    id: 'healthcare',
    topic: 'Healthcare',
    question: "We're a national healthcare provider and we're looking for a broad report on healthcare legislation federally.",
    description: 'National healthcare legislation overview for providers',
    icon: '🏥'
  },
  {
    id: 'travel',
    topic: 'Travel',
    question: 'Can you analyze travel indsutry regulations at the federal level?',
    description: 'Federal regulatory landscape for the travel industry',
    icon: '✈️'
  }
];

const DemoContext = createContext<DemoContextType | undefined>(undefined);

export const DemoProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isDemoMode, setIsDemoMode] = useState<boolean>(() => {
    const saved = localStorage.getItem('politheon-demo-mode');
    return saved === 'true';
  });

  const toggleDemoMode = () => {
    const newMode = !isDemoMode;
    setIsDemoMode(newMode);
    localStorage.setItem('politheon-demo-mode', newMode.toString());
  };

  const setDemoMode = (enabled: boolean) => {
    setIsDemoMode(enabled);
    localStorage.setItem('politheon-demo-mode', enabled.toString());
  };

  return (
    <DemoContext.Provider value={{ 
      isDemoMode, 
      toggleDemoMode, 
      setDemoMode, 
      sampleQuestions: defaultSampleQuestions 
    }}>
      {children}
    </DemoContext.Provider>
  );
};

export const useDemo = () => {
  const context = useContext(DemoContext);
  if (context === undefined) {
    throw new Error('useDemo must be used within a DemoProvider');
  }
  return context;
};
